import React from 'react'

import FormFramework, { Props } from '../framework/components/Form'
import FormErrorsHint from './FormErrorsHint'
import FormErrorCtx from './FormErrorCtx'
import FormSuccess from '../../typography/FormSuccess'

interface ChildProps extends Props {
  children: React.ReactNode
}

const Form: React.FC<ChildProps> = (props) => {
  return (
    <FormFramework
      FormErrorCtx={FormErrorCtx}
      FormErrorsHint={FormErrorsHint}
      FormSuccess={FormSuccess}
      {...props}
    >
      {props.children}
    </FormFramework>
  )
}

export default Form
